import { shape, string } from 'prop-types';

import styles from './CovidMessageBanner.scss';

export const CovidMessageBanner = ({ message: { title, text, href, linkLabel } }) => (
  <div className={styles.CovidMessageBanner}>
    <p className={styles.Title}>{title}</p>
    {text && <p className={styles.Text}>{text}</p>}
    {linkLabel && (
      <a className={styles.Button} href={href} target="_blank" rel="noopener noreferrer">
        {linkLabel}
      </a>
    )}
  </div>
);

CovidMessageBanner.propTypes = {
  message: shape({
    title: string.isRequired,
    text: string,
    href: string,
    linkLabel: string,
  }).isRequired,
};
